/** Portal Id 2 = Auxilior / AuxCap (see TermsOfUse, PrivacyPolicy). */
export const AUXCAP_PORTAL_ID = 2;

export const SUPPORT_PHONE_AUXCAP_DISPLAY = '877-773-0333';
export const SUPPORT_PHONE_AUXCAP_TEL = 'tel:+18777730333';

export const SUPPORT_PHONE_AVANT_DISPLAY = '888-412-8268';
export const SUPPORT_PHONE_AVANT_TEL = 'tel:+18884128268';

export const SUPPORT_EMAIL_US = 'customerservice@servicehqtrs.com';
export const SUPPORT_EMAIL_CA = 'cancustomerservice@servicehqtrs.ca';

export function isAuxCapPortal(portalId: string | number | null | undefined): boolean {
    return Number(portalId) === AUXCAP_PORTAL_ID;
}

export function getSupportPhoneDisplay(portalId: string | number | null | undefined): string {
    return isAuxCapPortal(portalId) ? SUPPORT_PHONE_AUXCAP_DISPLAY : SUPPORT_PHONE_AVANT_DISPLAY;
}

export function getSupportPhoneTel(portalId: string | number | null | undefined): string {
    return isAuxCapPortal(portalId) ? SUPPORT_PHONE_AUXCAP_TEL : SUPPORT_PHONE_AVANT_TEL;
}

/** Legal copy style e.g. 1-877-773-0333 / 1-888-412-8268 */
export function getSupportPhoneDisplayTollFree(portalId: string | number | null | undefined): string {
    return `1-${getSupportPhoneDisplay(portalId)}`;
}

/** Canada flow uses .ca mailbox; US uses .com. */
export function isCanadaBrowserLocation(): boolean {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('browserLocation') === '"Canada"';
}

export function getSupportEmailForLocation(): { email: string; mailto: string } {
    const isCanada = isCanadaBrowserLocation();
    const email = isCanada ? SUPPORT_EMAIL_CA : SUPPORT_EMAIL_US;
    return { email, mailto: `mailto:${email}` };
}
